import React from "react";
import PropTypes from "prop-types";

const Skeleton = ({ width, height }) => (
  <div className="rd--skeleton" style={{ width, height }}></div>
);

Skeleton.propTypes = {
  width: PropTypes.string.isRequired,
  height: PropTypes.string.isRequired,
};

Skeleton.defaultProps = {
  width: "100px",
  height: "20px",
};

export default Skeleton;
